// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/serviceImg/img_main03_03.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/serviceImg/bg_epg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/serviceImg/bg_epb.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/serviceImg/bg_epd.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/serviceImg/bg_epx.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (max-width: 1200px) {
  .wcompare {
    display: none;
  }
}
@media (min-width: 1200px) {
  .mcompare {
    display: none;
  }
}
.formt {
  font-size: 16pt;
  font-weight: bold;
  color: #0F3255;
}

.compare {
  overflow: hidden;
}

.compare table {
  border-collapse: collapse;
  border: 3px solid #F6F6F6;
  width: 100%;
}

.compare tr {
  border: 3px solid #F6F6F6;
  background-color: #009CDD;
}

.compare td {
  border: 3px solid #F6F6F6;
  background-color: #F6F6F6;
}

.compare .a1 {
  background-color: #0F3255;
  color: #FFFFFF;
  padding: 10px;
  font-weight: bold;
}

.compare .a2 {
  background-color: #cccccc;
  color: #0F3255;
  padding: 10px;
  font-weight: bold;
}

.compare .a3 {
  background-color: #FFC216;
  color: #0F3255;
  padding: 10px;
  font-weight: bold;
}

.compare .a4 {
  background-color: #eeeeee;
  padding: 10px;
  color: #444444;
  vertical-align: middle;
  font-weight: bold;
}

.compare .a5 {
  background-color: #ffffff;
  color: #444444;
  padding: 10px;
  vertical-align: middle;
  font-weight: bold;
}

.compare .new img {
  margin-top: 25px;
  float: left;
}

.compare .new .title2 {
  vertical-align: text-bottom;
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
  margin-left: 50px;
  margin-top: 50px;
}

.compare .new .sub {
  margin-left: 50px;
  font-size: 20px;
}

.compare .safe .title2 {
  vertical-align: text-bottom;
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
  margin-left: 50px;
  margin-top: 50px;
}

.compare .safe img {
  margin-top: 25px;
  float: left;
}

.compare .safe .sub {
  margin-left: 50px;
  font-size: 20px;
}

.compare .win {
  width: 50px;
  position: absolute;
  top: -70px;
  right: 0;
}

.compare .win2 {
  width: 50px;
  position: absolute;
  top: -115px;
  right: 0;
}

.compare .win3 {
  width: 50px;
  position: absolute;
  top: -190px;
  right: 0;
}

.compare .win4 {
  width: 50px;
  position: absolute;
  top: -45px;
  right: 0;
}

.compare .win5 {
  width: 50px;
  position: absolute;
  top: -70px;
  right: 0;
}

.compare .win6 {
  width: 50px;
  position: absolute;
  top: -55px;
  right: 0;
}

.compare .win7 {
  width: 50px;
  position: absolute;
  top: -70px;
  right: 0;
}

.compare .win_c {
  position: relative;
}

.cheack {
  width: 40px;
}

.ctbox {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #ccc;
  min-height: 200px;
  padding: 1.5em 0;
  text-align: center;
  background-color: #fff;
}

.ctl {
  border-left: 1px solid #ccc;
}

.clear-columns {
  display: none;
}

.ct-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ct-content p {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #d9534f; /* text-danger */
}

.ueit {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;
  color: #fff;
}

.marbk {
  width: 50%;
  margin-right: 7%;
  float: right;
  margin: 3em 0;
  line-height: 1.8em;
}

.marbk {
  width: 100%;
  float: none;
  margin: 4rem 0 0 0;
  margin-right: 7%;
  padding: 3%;
  line-height: 1.8em;
  color: #fff;
}

.marbk h3 {
  color: #ffbe46;
  line-height: 3em;
}

.width_c {
  width: 60%;
}

@media (max-width: 767px) {
  .ctbox {
    border: none;
    min-height: auto;
    padding: 1em 0;
  }
  .ct-content img {
    width: 50px;
    height: 50px;
  }
  .ct-content p {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .compare table {
    width: 100%;
  }
  .compare td {
    width: 100%;
    display: block;
    padding: 10px;
  }
  .compare .a1, .compare .a2, .compare .a3, .compare .a4, .compare .a5 {
    padding: 10px;
    font-size: 14px;
  }
  .compare .title {
    font-size: 14pt;
  }
  .compare .new img,
  .compare .safe img {
    width: 100%;
    float: none;
    margin: 0;
  }
  .compare .new .title2,
  .compare .safe .title2 {
    margin: 10px 0 0 0;
    font-size: 16px;
    line-height: 1.4;
    text-align: center;
  }
  .compare .new .sub,
  .compare .safe .sub {
    margin-left: 0;
    font-size: 14px;
    text-align: center;
  }
  .compare .win_c img {
    position: relative;
    top: 0;
    right: 0;
    width: 30px;
  }
}
@media (max-width: 1200px) {
  .coursevideo {
    width: 100%;
    margin-bottom: 2rem;
  }
}
.tit_ue {
  width: 95%;
  font-size: 1.6em;
}

.cpm {
  width: 45%;
}

.cpe {
  background-color: #fff9e7;
  font-size: 1.2em;
}

.eg {
  background-color: #e7f9ee;
}

.eb {
  background-color: #e9f9fc;
}

.ed {
  background-color: #e5f5fc;
}

.ex {
  background-color: #eaf1fb;
}

.egs {
  color: #0fc45b;
}

.ebs {
  color: #28c4e5;
}

.eds {
  color: #009cdd;
}

.exs {
  color: #3079d5;
}

.cpl {
  max-width: 550px;
  float: right;
  margin: 2em;
  text-align: right;
}

.cpr {
  max-width: 550px;
  float: left;
  margin: 2em;
}

.exs {
  color: #3079d5;
}

.cpit {
  background-color: #ffc216;
  color: #fff;
  text-align: center;
  padding-top: 2em;
}

.cpt {
  width: 10%;
}

.wt {
  background-color: #fff;
}

.compare table {
  border-collapse: collapse;
  border: 1px solid #F6F6F6;
  background-color: #009CDD;
  width: 100%;
}

.compare tr {
  border: 1px solid #F6F6F6;
  background-color: #009CDD;
}

.compare td {
  border: 1px solid #F6F6F6;
  background-color: #F6F6F6;
}

.compare .a1 {
  background-color: #0F3255;
  color: #FFFFFF;
  padding: 10px;
  font-weight: bold;
}

.compare .a2 {
  background-color: #3079D5;
  color: #FFFFFF;
  padding: 10px;
}

.compare .a3 {
  background-color: #FFC216;
  color: #FFFFFF;
  padding: 10px;
  color: #000000;
}

.compare .a4 {
  background-color: #FFFFFF;
  color: #FFFFFF;
  padding: 10px;
  color: #000000;
}

.titcp {
  font-size: 1.3em;
  color: #0083c7;
  text-align: center;
  background-color: #fff;
}

.epg, .epb, .epd, .epx {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: Contain;
  padding-top: 3em;
}

.epg {
  background-color: #0fc45b;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.epb {
  background-color: #28c4e5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.epd {
  background-color: #009cdd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.epx {
  background-color: #3079d5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@media screen and (max-width: 768px) {
  .xxx-hide {
    display: none;
  }
}
/* 桌機才啟用翻轉（保留你原本的 flip 規則放這裡） */
@media (hover: hover) and (pointer: fine) {
  .sixsq {
    cursor: pointer;
    perspective: 600;
  }
  .sqcard {
    height: 100%;
    transform-style: preserve-3d;
    transition: all 1s ease-in-out;
    width: 100%;
  }
  .sqcard:hover {
    transform: rotateX(180deg);
  }
  .sqcard .side {
    backface-visibility: hidden;
    height: 100%;
    overflow: hidden;
    width: 100%;
    position: absolute;
  }
  .sqcard .back {
    color: #ffffff;
    transform: rotateX(180deg);
    text-align: center;
  }
}
/* 手機關閉翻轉（顯示正面就好） */
@media (hover: none), (pointer: coarse) {
  .sqcard, .sqcard .side, .sqcard .back {
    transform: none !important;
    transition: none !important;
  }
  .sqcard .back {
    display: none !important;
  } /* 只出正面 */
}
.safe {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.safe .cheack {
  width: 48px; /* 桌機給固定小尺寸 */
  height: auto;
  object-fit: contain;
  display: block;
  flex: 0 0 auto;
}

.safe > .title2,
.safe > .sub {
  flex: 1 1 100%;
  min-width: 0;
}

@media (max-width: 576px) {
  .safe .cheack {
    display: none;
  } /* 手機不顯示圖示 */
  .safe {
    gap: 8px;
  } /* 間距收斂一點 */
  .safe .title2 {
    font-size: 1rem;
  }
  .safe .sub {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/service/styles/service.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC;IACC,aAAA;EAEA;AACF;AACA;EACC;IACC,aAAA;EACA;AACF;AACA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AACD;;AACA;EACC,gBAAA;AAED;;AAAA;EACC,yBAAA;EACA,yBAAA;EACA,WAAA;AAGD;;AAAA;EACC,yBAAA;EACA,yBAAA;AAGD;;AAAA;EACC,yBAAA;EACA,yBAAA;AAGD;;AAAA;EACC,yBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAGD;;AAAA;EACC,yBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAGD;;AAAA;EACC,yBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAGD;;AAAA;EACC,yBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AAGD;;AADA;EACC,yBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAID;;AADA;EACC,gBAAA;EACA,WAAA;AAID;;AAFA;EACC,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAKD;;AAHA;EACC,iBAAA;EACA,eAAA;AAMD;;AAJA;EACC,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAOD;;AALA;EACC,gBAAA;EACA,WAAA;AAQD;;AANA;EACC,iBAAA;EACA,eAAA;AASD;;AANA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AASD;;AAPA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAUD;;AARA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAWD;;AATA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAYD;;AAVA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAaD;;AAXA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAcD;;AAZA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAeD;;AAbA;EACC,kBAAA;AAgBD;;AAdA;EACC,WAAA;AAiBD;;AATA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAYD;;AAVE;EACD,2BAAA;AAaD;;AAVA;EACI,aAAA;AAaJ;;AAXA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAcD;;AAZA;EACC,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA,EAAA,gBAAA;AAeD;;AAbA;EACC,yDAAA;EACA,4BAAA;EACA,gCAAA;EACA,sBAAA;EACA,WAAA;AAgBD;;AAdA;EACC,UAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAiBD;;AAfA;EACC,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAkBD;;AAhBA;EACC,cAAA;EACA,gBAAA;AAmBD;;AAjBA;EACC,UAAA;AAoBD;;AAlBA;EACC;IACE,YAAA;IACA,gBAAA;IACA,cAAA;EAqBD;EAlBD;IACE,WAAA;IACA,YAAA;EAoBD;EAjBD;IACE,eAAA;EAmBD;AACF;AAjBA;EACC;IACC,WAAA;EAmBA;EAjBD;IACC,WAAA;IACA,cAAA;IACA,aAAA;EAmBA;EAjBD;IACC,aAAA;IACA,eAAA;EAmBA;EAjBD;IACC,eAAA;EAmBA;EAjBD;;IAEC,WAAA;IACA,WAAA;IACA,SAAA;EAmBA;EAjBD;;IAEC,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;EAmBA;EAjBD;;IAEC,cAAA;IACA,eAAA;IACA,kBAAA;EAmBA;EAjBD;IACC,kBAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;EAmBA;AACF;AAjBA;EACC;IACC,WAAA;IACA,mBAAA;EAmBA;AACF;AAjBA;EACC,UAAA;EACA,gBAAA;AAmBD;;AAjBA;EACC,UAAA;AAoBD;;AAlBA;EACC,yBAAA;EACA,gBAAA;AAqBD;;AAnBA;EAAM,yBAAA;AAuBN;;AAtBA;EAAM,yBAAA;AA0BN;;AAzBA;EAAM,yBAAA;AA6BN;;AA5BA;EAAM,yBAAA;AAgCN;;AA/BA;EACC,cAAA;AAkCD;;AAhCA;EACC,cAAA;AAmCD;;AAjCA;EACC,cAAA;AAoCD;;AAlCA;EACC,cAAA;AAqCD;;AAnCA;EACC,gBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAsCD;;AApCA;EACC,gBAAA;EACA,WAAA;EACA,WAAA;AAuCD;;AArCA;EACC,cAAA;AAwCD;;AAtCA;EACC,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAyCD;;AAvCA;EACC,UAAA;AA0CD;;AAxCA;EACC,sBAAA;AA2CD;;AAzCA;EACI,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,yBAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,yBAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AA4CJ;;AAzCA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AA4CJ;;AA1CA;EACC,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AA6CD;;AA3CA;EACC,4BAAA;EACA,+BAAA;EACA,wBAAA;EACA,gBAAA;AA8CD;;AA5CA;EACC,yBAAA;EACA,yDAAA;AA+CD;;AA7CA;EACC,yBAAA;EACA,yDAAA;AAgDD;;AA9CA;EACC,yBAAA;EACA,yDAAA;AAiDD;;AA/CA;EACC,yBAAA;EACA,yDAAA;AAkDD;;AAhDA;EACI;IACI,aAAA;EAmDN;AACF;AA9CA,+BAAA;AACA;EAEC;IACC,eAAA;IACA,gBAAA;EA+CA;EA7CD;IACC,YAAA;IACA,4BAAA;IACA,8BAAA;IACA,WAAA;EA+CA;EA7CD;IACC,0BAAA;EA+CA;EA7CD;IACC,2BAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;EA+CA;EA7CD;IACC,cAAA;IACA,0BAAA;IACA,kBAAA;EA+CA;AACF;AA3CE,mBAAA;AACA;EACD;IACE,0BAAA;IACA,2BAAA;EA6CD;EA3CD;IAAgB,wBAAA;EA8Cf,EA9C2C,SAAA;AA+C7C;AA7CE;EACD,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AA+CD;;AA5CE;EACD,WAAA,EAAA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AA+CD;;AA5CE;;EACc,cAAA;EAAgB,YAAA;AAiDhC;;AA/CE;EACD;IAAe,aAAA;EAmDd,EAnDiC,YAAA;EAClC;IAAO,QAAA;EAqDN,EArDkC,WAAA;EACnC;IAAe,eAAA;EAuDd;EAtDD;IAAY,iBAAA;EAyDX;AACF","sourcesContent":["@media (max-width:1200px) {\n\t.wcompare {\n\t\tdisplay: none;\n\t}\n}\n\n@media (min-width:1200px) {\n\t.mcompare {\n\t\tdisplay: none;\n\t}\n}\n.formt {\n\tfont-size: 16pt;\n\tfont-weight: bold;\n\tcolor: #0F3255;\n}\n.compare {\n\toverflow: hidden;\n}\n.compare table {\n\tborder-collapse: collapse;\n\tborder: 3px solid #F6F6F6;\n\twidth: 100%;\n}\n\n.compare tr {\n\tborder: 3px solid #F6F6F6;\n\tbackground-color: #009CDD;\n}\n\n.compare td {\n\tborder: 3px solid #F6F6F6;\n\tbackground-color: #F6F6F6;\n}\n\n.compare .a1 {\n\tbackground-color: #0F3255;\n\tcolor: #FFFFFF;\n\tpadding: 10px;\n\tfont-weight: bold;\n}\n\n.compare .a2 {\n\tbackground-color: #cccccc;\n\tcolor: #0F3255;\n\tpadding: 10px;\n\tfont-weight: bold;\n}\n\n.compare .a3 {\n\tbackground-color: #FFC216;\n\tcolor: #0F3255;\n\tpadding: 10px;\n\tfont-weight: bold;\n}\n\n.compare .a4 {\n\tbackground-color: #eeeeee;\n\tpadding: 10px;\n\tcolor: #444444;\n\tvertical-align: middle;\n\tfont-weight: bold;\n}\n.compare .a5 {\n\tbackground-color: #ffffff;\n\tcolor: #444444;\n\tpadding: 10px;\n\tvertical-align: middle;\n\tfont-weight: bold;\n}\n\n.compare .new img{\n\tmargin-top: 25px;\n\tfloat: left;\n}\n.compare .new .title2{\n\tvertical-align: text-bottom;\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tline-height: 50px;\n\tmargin-left: 50px;\n\tmargin-top: 50px;\n}\n.compare .new .sub {\n\tmargin-left: 50px;\n\tfont-size: 20px;\n}\n.compare .safe .title2{\n\tvertical-align: text-bottom;\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tline-height: 50px;\n\tmargin-left: 50px;\n\tmargin-top: 50px;\n}\n.compare .safe img{\n\tmargin-top: 25px;\n\tfloat: left;\n}\n.compare .safe .sub {\n\tmargin-left: 50px;\n\tfont-size: 20px;\n}\n\n.compare .win {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -70px;\n\tright: 0;\n}\n.compare .win2 {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -115px;\n\tright: 0;\n}\n.compare .win3 {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -190px;\n\tright: 0;\n}\n.compare .win4 {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -45px;\n\tright: 0;\n}\n.compare .win5 {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -70px;\n\tright: 0;\n}\n.compare .win6 {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -55px;\n\tright: 0;\n}\n.compare .win7 {\n\twidth: 50px;\n\tposition: absolute;\n\ttop: -70px;\n\tright: 0;\n}\n.compare .win_c {\n\tposition: relative;\n}\n.cheack {\n\twidth: 40px;\n}\n\n// .ctbox img {\n//     width: 60px;\n//     height: 60px;\n//     margin-bottom: 0.5em;\n// }\n.ctbox {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-right: 1px solid #ccc;\n\tmin-height: 200px;\n\tpadding: 1.5em 0;\n\ttext-align: center;\n\tbackground-color: #fff;\n  }\n  .ctl {\n\tborder-left: 1px solid #ccc;\n  }\n\n.clear-columns {\n    display: none;\n}\n.ct-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n  }\n.ct-content p {\n\tmargin: 0;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\tcolor: #d9534f; /* text-danger */\n  }\n.ueit {\n\tbackground-image: url(../../../../public/serviceImg/img_main03_03.jpg);\n\tbackground-repeat: no-repeat;\n\tbackground-position: left center;\n\tbackground-size: cover;\n\tcolor: #fff;\n}\n.marbk {\n\twidth: 50%;\n\tmargin-right: 7%;\n\tfloat: right;\n\tmargin: 3em 0;\n\tline-height: 1.8em;\n}\n.marbk {\n\twidth: 100%;\n\tfloat: none;\n\tmargin: 4rem 0 0 0;\n\tmargin-right: 7%;\n\tpadding: 3%;\n\tline-height: 1.8em;\n\tcolor: #fff;\n}\n.marbk h3 {\n\tcolor: #ffbe46;\n\tline-height: 3em;\n}\n.width_c {\n\twidth: 60%;\n}\n@media (max-width: 767px) {\n\t.ctbox {\n\t  border: none;\n\t  min-height: auto;\n\t  padding: 1em 0;\n\t}\n  \n\t.ct-content img {\n\t  width: 50px;\n\t  height: 50px;\n\t}\n  \n\t.ct-content p {\n\t  font-size: 14px;\n\t}\n  }\n@media (max-width: 767px) {\n\t.compare table {\n\t\twidth: 100%;\n\t}\n\t.compare td {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t\tpadding: 10px;\n\t}\n\t.compare .a1, .compare .a2, .compare .a3, .compare .a4, .compare .a5 {\n\t\tpadding: 10px;\n\t\tfont-size: 14px;\n\t}\n\t.compare .title {\n\t\tfont-size: 14pt;\n\t}\n\t.compare .new img,\n\t.compare .safe img {\n\t\twidth: 100%;\n\t\tfloat: none;\n\t\tmargin: 0;\n\t}\n\t.compare .new .title2,\n\t.compare .safe .title2 {\n\t\tmargin: 10px 0 0 0;\n\t\tfont-size: 16px;\n\t\tline-height: 1.4;\n\t\ttext-align: center;\n\t}\n\t.compare .new .sub,\n\t.compare .safe .sub {\n\t\tmargin-left: 0;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n\t}\n\t.compare .win_c img {\n\t\tposition: relative;\n\t\ttop: 0;\n\t\tright: 0;\n\t\twidth: 30px;\n\t}\n}\n@media (max-width:1200px) {\n\t.coursevideo {\n\t\twidth: 100%;\n\t\tmargin-bottom: 2rem;\n\t}\n}\n.tit_ue {\n\twidth: 95%;\n\tfont-size: 1.6em;\n}\n.cpm {\n\twidth: 45%;\n}\n.cpe {\n\tbackground-color: #fff9e7;\n\tfont-size: 1.2em;\n}\n.eg { background-color: #e7f9ee;}\n.eb { background-color: #e9f9fc;}\n.ed { background-color: #e5f5fc;}\n.ex { background-color: #eaf1fb;}\n.egs { \n\tcolor: #0fc45b;\n}\n.ebs { \n\tcolor: #28c4e5;\n}\n.eds { \n\tcolor: #009cdd;\n}\n.exs { \n\tcolor: #3079d5;\n}\n.cpl {\n\tmax-width: 550px;\n\tfloat: right;\n\tmargin: 2em ;\n\ttext-align: right;\n}\n.cpr {\n\tmax-width: 550px;\n\tfloat: left;\n\tmargin: 2em ;\n}\n.exs { \n\tcolor: #3079d5;\n}\n.cpit {\n\tbackground-color: #ffc216;\n\tcolor: #fff;\n\ttext-align: center;\n\tpadding-top: 2em;\n}\n.cpt {\n\twidth: 10%;\n}\n.wt {\n\tbackground-color: #fff;\n}\n.compare table {\n    border-collapse: collapse;\n    border: 1px solid #F6F6F6;\n    background-color: #009CDD;\n    width: 100%;\n}\n\n.compare tr {\n    border: 1px solid #F6F6F6;\n    background-color: #009CDD;\n}\n\n.compare td {\n    border: 1px solid #F6F6F6;\n    background-color: #F6F6F6;\n}\n\n.compare .a1 {\n    background-color: #0F3255;\n    color: #FFFFFF;\n    padding: 10px;\n    font-weight: bold;\n}\n\n.compare .a2 {\n    background-color: #3079D5;\n    color: #FFFFFF;\n    padding: 10px;\n}\n\n.compare .a3 {\n    background-color: #FFC216;\n    color: #FFFFFF;\n    padding: 10px;\n    color: #000000;\n}\n\n.compare .a4 {\n    background-color: #FFFFFF;\n    color: #FFFFFF;\n    padding: 10px;\n    color: #000000;\n}\n.titcp {\n\tfont-size: 1.3em;\n\tcolor: #0083c7;\n\ttext-align: center;\n\tbackground-color: #fff;\n}\n.epg, .epb, .epd, .epx {\n\tbackground-repeat: no-repeat;\n\tbackground-position: top center;\n\tbackground-size: Contain;\n\tpadding-top: 3em;\n}\n.epg { \n\tbackground-color: #0fc45b;\n\tbackground-image: url(../../../../public/serviceImg/bg_epg.png);\n}\n.epb { \n\tbackground-color: #28c4e5;\n\tbackground-image: url(../../../../public/serviceImg/bg_epb.png);\n}\n.epd { \n\tbackground-color: #009cdd;\n\tbackground-image: url(../../../../public/serviceImg/bg_epd.png);\n}\n.epx { \n\tbackground-color: #3079d5;\n\tbackground-image: url(../../../../public/serviceImg/bg_epx.png);\n}\n@media screen and (max-width: 768px) {\n    .xxx-hide {\n        display: none;\n    }\n}\n\n\n\n/* 桌機才啟用翻轉（保留你原本的 flip 規則放這裡） */\n@media (hover: hover) and (pointer: fine) {\n\t// 六格特效\n\t.sixsq {\n\t\tcursor: pointer;\n\t\tperspective: 600;\n\t}\n\t.sqcard {\n\t\theight: 100%;\n\t\ttransform-style: preserve-3d;\n\t\ttransition: all 1s ease-in-out;\n\t\twidth: 100%;\n\t}\n\t.sqcard:hover {\n\t\ttransform: rotateX(180deg);\n\t}\n\t.sqcard .side {\n\t\tbackface-visibility: hidden;\n\t\theight: 100%;\n\t\toverflow: hidden;\n\t\twidth: 100%;\n\t\tposition: absolute;\n\t}\n\t.sqcard .back {\n\t\tcolor: #ffffff;\n\t\ttransform: rotateX(180deg);\n\t\ttext-align: center;\n\t\t\n\t}\n  }\n  \n  /* 手機關閉翻轉（顯示正面就好） */\n  @media (hover: none), (pointer: coarse) {\n\t.sqcard, .sqcard .side, .sqcard .back {\n\t  transform: none !important;\n\t  transition: none !important;\n\t}\n\t.sqcard .back { display: none !important; } /* 只出正面 */\n  }\n  .safe{\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 12px;\n\tflex-wrap: wrap;\n  }\n  \n  .safe .cheack{\n\twidth: 48px;               /* 桌機給固定小尺寸 */\n\theight: auto;\n\tobject-fit: contain;\n\tdisplay: block;\n\tflex: 0 0 auto;\n  }\n  \n  .safe > .title2,\n  .safe > .sub{ flex: 1 1 100%; min-width: 0; }\n  \n  @media (max-width: 576px){\n\t.safe .cheack{ display: none; }   /* 手機不顯示圖示 */\n\t.safe{ gap: 8px; }                 /* 間距收斂一點 */\n\t.safe .title2{ font-size: 1rem; }\n\t.safe .sub{ font-size: .9rem; }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
